module.exports = __webpack_public_path__ + "media/images/pic/brodno/speaking-64ad1161e36283b97ed4707517b1544f.png";